declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../animations/router.animations';
import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, MaterialConsumptionEntries2Controller, MaterialConsumptionEntriesRequest } from '../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../src/app/ncs/services/actor.service';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';
import { NgbCameraUploadModal } from '../profile/patientprofileview/personaldetailview/modal/cameraupload.modal';
import { NgbAddNewPatient } from '../provider/dashboard/modal/addnewpatient.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { ConsumptionEntrypipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';





@Component({
  selector: 'consumptionentrydas',
  templateUrl: './consumptionentrydas.component.html',
  styleUrls: [
    './consumptionentrydas.component.scss']
  , animations: [routerTransition()]
})

export class ConsumptionEntryDasComponent implements OnInit {

  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
  }
  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }

  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public ShowRegister: boolean = true;
  public Showrow: boolean = true;
  public ShowPatientDetails: boolean = false;
  SelectedFromDate: NgbDateStruct;
  SelectedToDate: NgbDateStruct;
  TodayDate = new Date();
  public isRequesting: boolean = false;
  public searchValue: string;
  public searchText: any;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;

  CurrentMaterialConsumptionEntries2Controller: MaterialConsumptionEntries2Controller[];
  CurrentMaterialConsumptionEntriesRequest: MaterialConsumptionEntriesRequest;
  LoadPatients() {
    this.CurrentMaterialConsumptionEntriesRequest = new MaterialConsumptionEntriesRequest();

    // this.CurrentIahOrdersRequest.BranchCode = AppData.Instance().SelectedBranchCode;


    this.CurrentMaterialConsumptionEntriesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
    this.GetMaterialConsumptionEntries2();
  }

  GetMaterialConsumptionEntries2() {
    this.StartRefreshing();
    this.CurrentMaterialConsumptionEntriesRequest.ConditionalOperator = 10;
    this.CurrentMaterialConsumptionEntriesRequest.BranchCode = AppData.Instance().SelectedBranchCode;
    this.CurrentMaterialConsumptionEntriesRequest.FromDate = new Date();
    this.CurrentMaterialConsumptionEntriesRequest.ToDate = new Date();

    this.actorservice.GetMaterialConsumptionEntries2(this.CurrentMaterialConsumptionEntriesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentMaterialConsumptionEntries2Controller = this.ApiResData.Result;
          this.pdata = this.CurrentMaterialConsumptionEntries2Controller;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    public printService: PrintService,
    private route: ActivatedRoute,
    private filter: ConsumptionEntrypipe, private loginservice: LoginService, private parserFormatter: NgbDateParserFormatter, ) { }

  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();
    this.SelectedToDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 2, day: this.TodayDate.getDate() };
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    this.LoadPatients();
    //this.GetPatientInfoByFormattedCodeController();

  }



  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }


  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  SelectedPatient: PatientInfoByFormattedCodeController;
  ViewPatientDetails(objCategory: any) {
    var patient: PatientInfoByFormattedCodeController = objCategory;

    if (patient != null) {



      this.ShowPatientDetails = true;
      this.ShowList = false;
      this.SelectedPatient = patient;
      this.Showarrow = true;
      this.Showrow = false;
      this.ShowRegister = false;
      //this.LoadPatientdetails()

    }
    else {
      this.ShowPatientDetails = false;
    }
  }
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentMaterialConsumptionEntries2Controller;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentMaterialConsumptionEntries2Controller,
          this.listFilter);
      }
    }
  }
  dataChanged(newobj) {
    this._GetMaterialConsumptionEntries2();
  }
  _GetMaterialConsumptionEntries2() {
    this.StartRefreshing();
    this.CurrentMaterialConsumptionEntriesRequest.ConditionalOperator = 10;
    this.CurrentMaterialConsumptionEntriesRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.CurrentMaterialConsumptionEntriesRequest.ToDate = new Date();

    this.actorservice.GetMaterialConsumptionEntries2(this.CurrentMaterialConsumptionEntriesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentMaterialConsumptionEntries2Controller = this.ApiResData.Result;

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetMaterialConsumptionEntries2();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetMaterialConsumptionEntries2();
    //ind++;
  }

  OpenBill() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.result.then((val: string) => {

      this.router.navigate(['healins/Consumptionreceipt', { FormattedCodedata: val, Code: 0 }]);

      // modalRef.componentInstance.FormattedCode = val;
      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetTreatmentCyclesController() })
    });
  }
  capture(l: PatientInfoByFormattedCodeController) {
    const modalRef = this.modalService.open(NgbCameraUploadModal,
      {
        centered: true,


      })
    modalRef.componentInstance.ActorCode = l.ActorCode;
    modalRef.componentInstance.Photo = l.Photo;
  }

  Consumptionreceipt(l: MaterialConsumptionEntries2Controller) {
    this.router.navigate(['healins/Consumptionreceipt2', {
      FormattedCodedata: l.PatientFormattedCode, Code: l.EntryCode,
      ConsumptionGroupCode: l.ConsumptionGroupCode, ConsumptionGroupName: l.ConsumptionGroupName,
      StoreCode: l.StoreLocation, StoreName: l.StoreLocationName,
      IsEntryUpdated: l.IsEntryUpdated
    }]);
  }
  printconsumption() {
    this.printService.printDocument("consumptionPV",
      {
        SelectedFromDate: this.SelectedFromDate, SelectedToDate: this.SelectedToDate, Day: this.SelectedFromDate.day, year: this.SelectedFromDate.year, month: this.SelectedFromDate.month
      }
    );
  }
}
